module.exports = __webpack_public_path__ + "img/897.215cbcd9.png";